import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dmcpd-wrapper" }
const _hoisted_2 = { class: "row table-headings" }
const _hoisted_3 = { class: "col d-flex align-items-center mx-0 g-0 title-row" }
const _hoisted_4 = {
  key: 1,
  class: "no-documents row"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  class: "text-center pt-5 pb-6"
}
const _hoisted_7 = { class: "bg-light-danger text-danger p-5" }
const _hoisted_8 = {
  key: 1,
  class: "text-center py-5 text-gray-700"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border w-20px h-20px" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "text-center py-5 text-gray-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_card = _resolveComponent("document-card")!
  const _component_the_pagination = _resolveComponent("the-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableConfig, (title) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (title.id !== 'actions')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.titleClasses(title))
                }, _toDisplayString(title.label), 3))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(_ctx.titleClasses(title))
                }, _toDisplayString(title.label), 3))
          ], 64))
        }), 256))
      ])
    ]),
    (_ctx.documents.length !== 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["row mb-8 documents", { 'g-5': _ctx.gridView, 'me-0 ms-0': !_ctx.gridView }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedDocuments, (document) => {
            return (_openBlock(), _createBlock(_component_document_card, _mergeProps({ appearance: _ctx.appearance }, document, {
              key: document.document.id,
              class: !_ctx.gridView && 'card-row',
              "client-product-id": _ctx.clientProduct.id,
              showContextMenu: false,
              "table-config": _ctx.tableConfig
            }), null, 16, ["appearance", "class", "client-product-id", "table-config"]))
          }), 128))
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1)
                ]))
              : (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
                    _createTextVNode(" Obteniendo información del expediente... "),
                    _hoisted_9
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_10, "No hay documentos que mostrar"))
          ])
        ])),
    _createVNode(_component_the_pagination, {
      "total-items": _ctx.totalDocuments,
      "page-items": _ctx.perPageDocuments,
      "item-label": "Documentos",
      page: _ctx.currentPage,
      onPageChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage($event)))
    }, null, 8, ["total-items", "page-items", "page"])
  ]))
}